import React, { useEffect } from "react";
import ReservationSection from "../components/ReservationSection/ReservationSection"; // Assure-toi du bon chemin d'importation
import "./ReservationPage.css"; // Si tu as besoin de styles spécifiques à la page

const ReservationPage = () => {
  useEffect(() => {
    // Définir le titre de la page de réservation
    document.title = "AMSEBRID - Location de voitures à Bejaia";
  }, []);

  return (
    <div className="reservation-page">
      <ReservationSection />
      {/* Si tu as d'autres sections ou éléments à ajouter, tu peux les inclure ici */}
    </div>
  );
};

export default ReservationPage;
